export const eventQAs = [
    {
        question: 'How do I get there?',
        answer: `The Grove is located at Chandler's Cross, Hertfordshire, WD3 4TG, approximately 1 h 15 min drive (22.2 miles) from Central London via the M1 or M25.

        If you are travelling by car, please note – the postcode WD17 3NL gives a more accurate position. Once at The Grove, all players are requested to drive to the 'Golfers Bag Drop' situated outside the Golf Reception.`
    },
    {
        question: 'What can I expect on the day?',
        answer: `Players must register upon arrival. We will be serving a simple breakfast in the Players Lounge from 11:30am to 13:30pm. Players are welcome to use the Driving Range for practice before the tee off at 12:50pm. The 18 hole course takes approximately 5 hours to complete. After the tournament, players will be invited to The Stables Courtyard for post golf refreshments. This will be followed by a three-course buffet dinner and prize ceremony at the Players Lounge. 

        Please refer to the full event programme below.
        
        Event programme:
        
        11:30-13:30: Registration & Welcome
        
        12:00-13:30: Driving Range Practice
        
        12:50-13:40: Two Tee Start (18 Hole Golf Course)
        
        17:30-18:40: Post Golf Refreshments
        
        18:40-20:30: Dinner`
    },
    {
        question: 'Which golf format will be followed?',
        answer: `The tournament will follow a Texas Scramble format.

        A Texas Scramble is a four-person team scramble, requiring a minimum number of tee shots of each member of the team to be used during the round.`
    },
    {
        question: 'What do I need to bring?',
        answer: `Players must bring their own clubs and bag. Please refer to The Grove's website for information on rental sets. To avoid disappointment, The Grove recommends booking any hire items in advance by emailing tee.time@thegrove.co.uk.

        Please refer to the 'What's Included'-section of the event page for further information.
        
        NB: Players should be advised that The Grove does not allow ‘metal spikes’ on the course. `
    },
]